import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3302ROLES } from '../../U3302';
import type { U3302CategoryFormRow } from '../../U3302Service';

interface U3302CategoryFormToolBarProps {
  formStateHandlers: U2000FormStateHandlers<U3302CategoryFormRow> & {
    getData: () => U3302CategoryFormRow | null;
    getFormState: () => U2000FormStateEnumState;
    addNewCategory: () => void;
    modifyCategory: () => void;
    deleteCategory: () => void;
  };
}

export const U3302CategoryFormToolBar: React.FC<U3302CategoryFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const data = formStateHandlers.getData();
  const isSystem = data?.origin === 'SYSTEM';
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3302ROLES.ADD),
      handleClick: () => formStateHandlers.addNewCategory(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3302ROLES.EDIT),
      handleClick: () => formStateHandlers.modifyCategory(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3302ROLES.DELETE),
      handleClick: () => formStateHandlers.deleteCategory(),
      disabled: formState === U2000FormStateEnumState.EDIT || isSystem,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
